import { Layout, Section } from 'layout';
import { PricesScreen } from 'pages/prices/screens/prices-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const PricesPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route path={`${match.url}/list`} component={PricesScreen} />
          <Redirect to={`${match.url}/list`} exact />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default PricesPage;
